<template>
  <transition name="modal-fade">
    <div
      v-if="visible"
      class="modal-overlay"
      @click.self="$emit('close')"
    >
      <transition name="modal-scale">
        <div
          v-if="visible"
          class="modal-container"
          :class="sizeClass"
        >
          <!-- Header -->
          <div class="modal-header">
            <div class="header-content">
              <div
                v-if="iconClass"
                class="header-icon"
                :class="iconColorClass"
              >
                <i :class="iconClass" />
              </div>
              <h3 class="modal-title">
                {{ title }}
              </h3>
            </div>
            <button
              class="close-btn"
              @click="$emit('close')"
            >
              <i class="fas fa-times" />
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <slot />
          </div>

          <!-- Footer -->
          <div
            v-if="$slots.footer"
            class="modal-footer"
          >
            <slot name="footer" />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Modal'
    },
    iconClass: {
      type: String,
      default: ''
    },
    iconColorClass: {
      type: String,
      default: 'green'
    },
    size: {
      type: String,
      default: 'md',
      validator: val => ['sm', 'md', 'lg'].includes(val)
    }
  },
  computed: {
    sizeClass () {
      return `modal-${this.size}`
    }
  },
  watch: {
    visible (val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  beforeDestroy () {
    document.body.style.overflow = ''
  }
}
</script>

<style>
@import '../../../assets/css/landing/modals/modals.css';

/* BaseModal specific transitions */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-scale-enter-active,
.modal-scale-leave-active {
  transition: all 0.3s ease;
}

.modal-scale-enter,
.modal-scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
